import { Outlet } from "react-router-dom";

const AuthentifiedLayout = () => (
    <>
        <Outlet />
    </>
);

export default AuthentifiedLayout;
